import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';

import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { DS_SIZE_MAP } from 'Components/ComponentLibrary/DesignSystem/sizes';
import ClientAgreementTextCardDynamic from 'Views/Onboarding/Pages/ClientAgreement/ClientAgreementTextCardDynamic';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { dataAttrs } from 'Helpers/Testing';
import Actions from '../../Components/Actions';

import OnboardingHeader from '../../Components/Header';
import ClientAgreementFinePrint from './ClientAgreementFinePrint';
import { useClientAgreementContext } from './ClientAgreementContext';
import ClientAgreementErrorList from './ClientAgreementErrorList';
import { metaOverrideSet } from './SignerMultiPicklist';

const styles = (theme) => ({
  root: {},
  header: {
    padding: theme.spacing(4, 0),
  },
  theFinePrint: {
    margin: theme.spacing(4, 0),
  },
  textCard: {
    margin: theme.spacing(4, 0),
  },
  actions: {},
  clientAgreementAlertMessage: {
    marginTop: theme.spacing(2),
  },
});

const ClientAgreement = ({
  className,
  classes,
}) => {
  const {
    isAcceptAgreementDisabled,
    isAccepting,
    handleAcceptAgreement,
    billingInformationResource,
    setSignedAgreement,
  } = useClientAgreementContext();

  useScrollTopOnMount();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {/* -------- Main Header -------- */}
      <OnboardingHeader
        title={'Member Agreement'}
        subTitle={'Please read and sign the agreement below'}
        centered
      />

      {/* -------- Client Agreement Text Body -------- */}
      <ClientAgreementTextCardDynamic
        className={classes.textCard}
      />

      {/* -------- Client Agreement Fine Print -------- */}
      <ClientAgreementFinePrint
        className={classes.theFinePrint}
      />

      {/* -------- Client Agreement Checkboxes  -------- */}
      <MetaControl
        {...dataAttrs('sign-agreement-checkbox')}
        attrName="signedAgreement"
        resource={billingInformationResource}
        onChange={setSignedAgreement}
        metaOverrideSet={metaOverrideSet}
      />

      {/* -------- Client Agreement Errors -------- */}
      <ClientAgreementErrorList />

      <Actions className={classes.actions}>
        {/* -------- Referrer Agreement Agree Button -------- */}
        <RoundedButton
          className={classes.referrerAgreementButton}
          onClick={handleAcceptAgreement}
          disabled={isAcceptAgreementDisabled}
          variant={'contained'}
          isLoading={isAccepting}
          test={'client-agreement-agree-button'}
          color={'primary'}
          fullWidth
          disableElevation
          size={DS_SIZE_MAP.sm}
        >
          {'Continue'}
        </RoundedButton>
      </Actions>
    </Box>
  );
};

ClientAgreement.defaultProps = {
  className: '',
};

ClientAgreement.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ClientAgreement);
